var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tokenAlive)?_c('div',{class:{'only-show-content':_vm.onlyShowContent},attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }